export default "__VITE_ASSET__Dj2wMSd7__"